module.exports = __webpack_public_path__ + "img/geod_5.90c7e4e8.jpg";